import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { FilePickerComponent } from './file-picker.component';
import { NoResultsModule } from "../../default/no-results/no-results.module";
import { FormModule } from "../../default/form/form.module";
import { FormPipeModule } from "../../../pipes/form/form-pipe.module";
import { FileSelectorModule } from "../../../directives/file-selector/file-selector.module";
import { AttachmentChipsModule } from "../attachment-chips/attachment-chips.module";
import { GridMediaViewerModule } from "../grid-media-viewer/grid-media-viewer.module";


@NgModule({
  declarations: [FilePickerComponent],
	imports: [
		CommonModule,
		NoResultsModule,
		FileSelectorModule,
		GridMediaViewerModule,
		MatIconModule,
		MatTooltipModule,
		TranslateModule,
		MatFormFieldModule,
		FormModule,
		FormPipeModule,
		AttachmentChipsModule,
	],
  exports:[FilePickerComponent]
})
export class FilePickerModule { }
